import "../Assets/styles/clients.css"
import { CiStar } from "react-icons/ci";
import img1 from '../Assets/images/test1.jpeg'
import img2 from '../Assets/images/test3.jpeg'

function Caro() {

  const Test  = [
    {
      text: "Working with the Ignio team has really given a boost to my productivity, I went from struggling to execute a single idea to running multiple products within a short period of time",
      author: "Jennifer Davies",
      position: "Project manager",
      image: img1
    }, 
    {
      text: "I never realized how easy it could be to build my very own SaaS prior to meeting the Ignio team. They were professional and made sure that I was on track with what I wanted to achieve.",
      author: "Olawale Johnson",
      position: "Student",
      image: img2
    },
    {
      text: "As a senior developer, I always had lots of ideas build, time was my main constraint, working with the Ignio team has really helped me optimize time from ideastion to execution",
      author: "John Doe",
      position: "Senior Developer",
      image: img1
    },
  ];
  return (
    <>
      <div className="container-lg">
        <div className="row">
          
          {Test.map((Testimonial, index) => (
            <div key={index} className="col-lg-4 col-md-6 testimonial-sub" data-aos="fade-up" data-aos-duration="1000ms">
              <div className="testing">
              <img src={Testimonial.image} alt={Testimonial.author} />
              <p>{Testimonial.text}</p>
              <h3>{Testimonial.author}</h3>
              <p className='italo'> {Testimonial.position}</p>
              <span>
                <CiStar style={{height:"20px"}}/>
                <CiStar style={{height:"20px"}}/>
                <CiStar style={{height:"20px"}}/>
                <CiStar style={{height:"20px"}}/>
                <CiStar style={{height:"20px"}}/>
              </span>
              </div>
            </div>
          ))}    
        </div>
      </div>
    </>    
  );
}

export default Caro;
